/**
 * Typed analytics sink. Posts to `window.dataLayer` when present (GTM-compatible);
 * silently no-ops otherwise. Swap to Plausible / PostHog / whatever by changing `sink`.
 */ function sink(item) {
    if (typeof window === 'undefined') return;
    if (!window.dataLayer) return;
    window.dataLayer.push(item);
}
/** Fire an analytics event. Safe to call on mount inside React components. */ export function track(event) {
    switch(event.type){
        case 'view_product':
        case 'add_to_cart':
            {
                const p = event.payload;
                sink({
                    event: event.type,
                    item_id: p.itemId,
                    item_name: p.itemName,
                    price_cents: p.priceCents,
                    slug: p.slug,
                    quantity: p.quantity ?? 1
                });
                return;
            }
        case 'begin_checkout':
            {
                sink({
                    event: 'begin_checkout',
                    item_count: event.payload.itemCount,
                    subtotal_cents: event.payload.subtotalCents
                });
                return;
            }
        case 'purchase':
            {
                sink({
                    event: 'purchase',
                    order_id: event.payload.orderId,
                    total_cents: event.payload.totalCents
                });
                return;
            }
    }
}
